import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, ArrowRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24">
      {/* Tier 1 — Slim white "thanks" band, mirrors the header */}
      <div className="bg-white border-t border-[#062632]/10 relative overflow-hidden">
        <div
          aria-hidden="true"
          className="absolute inset-0 pointer-events-none opacity-[0.05]"
          style={{
            backgroundImage: "radial-gradient(circle, #062632 1px, transparent 1px)",
            backgroundSize: "18px 18px",
          }}
        />
        <div aria-hidden="true" className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#0dd3ce]/40 to-transparent" />
        <div className="relative px-6 md:px-10 lg:px-16 py-7 flex flex-col md:flex-row items-start md:items-center justify-between gap-5">
          <div className="flex items-center gap-4">
            <img src="/brand/a3-sagar-logo-transparent.png" alt="A3 Sagar" className="h-10 w-auto" />
            <div className="leading-tight">
              <div className="text-[15px] font-extrabold tracking-tight text-[#062632]">Ready to start a build?</div>
              <div className="text-[12px] text-[#062632]/60">Send us your drawing — we'll come back with material guidance, tooling thoughts, and a clean quote.</div>
            </div>
          </div>
          <Link
            to="/rfq"
            data-testid="footer-cta-rfq"
            className="inline-flex items-center gap-2 bg-[#062632] text-white font-semibold px-6 py-3 text-[13px] tracking-tight rounded-full hover:bg-[#0a3845] transition-colors shrink-0"
          >
            Request a Quote <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>

      {/* Tier 2 — Dark navy footer body */}
      <div className="bg-[#03161D] relative overflow-hidden">
        <div
          aria-hidden="true"
          className="absolute inset-0 pointer-events-none opacity-[0.04]"
          style={{
            backgroundImage: "radial-gradient(circle, #0dd3ce 1px, transparent 1px)",
            backgroundSize: "22px 22px",
          }}
        />
        <div className="relative px-6 md:px-10 lg:px-16 py-16 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-display text-2xl font-extrabold tracking-tight text-slate-50">A3 SAGAR POLYMERS</div>
            <p className="text-sm text-slate-400 mt-5 max-w-md leading-relaxed">
              The industrial-scale evolution of Sagar Plastics — two decades of plastic moulding heritage,
              now engineered for high-tonnage production from our Mumbai Gala.
            </p>
            <div className="mt-6 flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-[#0dd3ce]/80 font-semibold">
              <span className="w-1.5 h-1.5 bg-[#0dd3ce] rounded-full" />
              ISO-Ready · B2B · Mumbai · India
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.25em] text-[#0dd3ce] font-semibold mb-5">Reach Us</div>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#0dd3ce]/70" /> Industrial Gala, Mumbai, MH, India</li>
              <li className="flex items-start gap-2"><Mail className="w-4 h-4 mt-0.5 text-[#0dd3ce]/70" /> sales@a3sagar.com</li>
              <li className="flex items-start gap-2"><Phone className="w-4 h-4 mt-0.5 text-[#0dd3ce]/70" /> +91 22 0000 0000</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.25em] text-[#0dd3ce] font-semibold mb-5">Navigate</div>
            <ul className="grid grid-cols-2 gap-3 text-sm">
              <li><a href="/#capabilities" className="text-slate-400 hover:text-[#0dd3ce] transition-colors">Capabilities</a></li>
              <li><a href="/#legacy" className="text-slate-400 hover:text-[#0dd3ce] transition-colors">Our Story</a></li>
              <li><Link to="/rfq" className="text-slate-400 hover:text-[#0dd3ce] transition-colors" data-testid="footer-rfq-link">Request a Quote</Link></li>
              <li><Link to="/admin/login" className="text-slate-400 hover:text-[#0dd3ce] transition-colors" data-testid="footer-admin-link">Team Login</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom strap */}
        <div className="relative border-t border-[#0a3a47] px-6 md:px-10 lg:px-16 py-5 flex flex-col md:flex-row gap-2 justify-between text-xs text-slate-500">
          <span>© {new Date().getFullYear()} A3 Sagar Polymers. Continuing the Sagar Plastics legacy.</span>
          <span className="tracking-[0.22em] uppercase text-slate-600">Built with grit · Engineered to spec</span>
        </div>
      </div>
    </footer>
  );
}
